import {StyleSheet} from 'react-native';
import {FONTS} from '../../../utils/Constants';

// Theme-aware styles factory (docs/DARK-MODE.md).
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    leftContainer: {
      flex: 1,
      alignItems: 'flex-start',
    },
    rightContainer: {
      flex: 1,
      alignItems: 'flex-end',
    },
    titleStyle: {
      fontFamily: FONTS.boldFont,
      fontSize: 18,
      color: colors.textSecondary,
      flex: 4,
      textAlign: 'center',
    },
  });

export default makeStyles;
